import TalkMessageItem from "./talkMessageItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class TalkMessageItemLeft extends TalkMessageItem {
    // LIFE-CYCLE CALLBACKS:

    onLoad() {
    }

    start() {
        this.node.opacity = 1;
    }

    setMessageText(text: string, name: string, time: string) {
        super.setMessageText(text, name, time);
        const maxWidth = 1080 * 0.45;
        this.scheduleOnce(() => {
            //
            if (this.lbMessageText.node.width >= maxWidth) {
                this.lbMessageText.overflow = cc.Label.Overflow.RESIZE_HEIGHT;
                this.lbMessageText.node.width = maxWidth;
                this.scheduleOnce(this.updateContentSize.bind(this, true));
            } else {
                this.scheduleOnce(this.updateContentSize.bind(this, false));
            }
        });
    }

    protected updateContentSize(isMuit: boolean) {
        this.node.opacity = 255;
        if (isMuit) {
            this.ndBg.width = this.lbMessageText.node.width + 35;
        } else {
            this.ndBg.width = this.lbMessageText.node.width + 45;
        }
        this.ndBg.height = this.lbMessageText.node.height /*+ 15*/;
        this.node.height = this.ndBg.height + 105;
    }

    // update (dt) {}
}
